import { Action } from '@ngrx/store';

export const NUMBER_PRODUCT = 'NUMBER_PRODUCT';
export const CART_BEFORE_LOGIN = 'CART_BEFORE_LOGIN';

export class NumberProduct implements Action {
  readonly type = NUMBER_PRODUCT;
  constructor(
    public payload: {
      numberProduct: number;
    }
  ) {}
}

export class CartBeforeLogin implements Action {
  readonly type = CART_BEFORE_LOGIN;
  constructor(
    public payload: {
      data: any;
    }
  ) {}
}

export type ReservationAction = NumberProduct | CartBeforeLogin;
